import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useRoutes, useLocation, useNavigate } from "react-router-dom";
import AppRoute from './config/app-route.jsx';
// Bootstrap CSS comes from scss/default/online-ordering-theme.scss (single copy)
// No `import 'bootstrap'` JS: OnlineOrdering uses no data-bs-* plugins; modals are custom (OnlineOrderingModal).

// css
import './styles/tokens.css';
// Font Awesome all.css removed from critical path — use src/icons/orderingIcons or react-icons/fi
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import './styles/serveiq-shimmer.css';
import './styles/responsive.css';
import './styles/mobile-components.css';
import './styles/bootstrap-migration.css';
// Order-type modals (Home + Checkout): load with main bundle to avoid flaky lazy-chunk timeouts in dev
import './components/online-ordering/OrderTypeModals/OrderTypeModal.css';
// MobileBottomNav was split into a nested async chunk with the online-ordering barrel and often hit ChunkLoadError (timeout) in dev; keep it on the entry bundle.
import './components/online-ordering/MobileBottomNav/MobileBottomNav.jsx';
import './scss/react.scss';
import './styles/typography.css';
import { store } from "./app/store.js";
import { Provider } from "react-redux";
import { ToastContainer } from 'react-toastify';
import { RouteFallbackShimmer } from './components/online-ordering/Shimmer/ShimmerPrimitives';


const container = document.getElementById('root');
const root = createRoot(container);

function NormalizePath() {
	const location = useLocation();
	const navigate = useNavigate();

	React.useEffect(() => {
		const normalizedPath = location.pathname.replace(/\/{2,}/g, "/");
		if (normalizedPath !== location.pathname) {
			navigate(
				`${normalizedPath}${location.search}${location.hash}`,
				{ replace: true }
			);
		}
	}, [location.pathname, location.search, location.hash, navigate]);

	return null;
}

function App() {
	let element = useRoutes(AppRoute);
	return (
		<>
			<NormalizePath />
			{element}
		</>
	);
}

const routeFallback = (
	<div className="d-flex justify-content-center align-items-center min-vh-100 bg-light" role="status">
		<RouteFallbackShimmer />
		<span className="visually-hidden">Loading…</span>
	</div>
);

root.render(
	<BrowserRouter>
		<Provider store={store}>
		<ToastContainer 
			style={{ zIndex: 99999 }}
			toastStyle={{ zIndex: 99999 }}
		/>
			<Suspense fallback={routeFallback}>
				<App />
			</Suspense>
		</Provider>
	</BrowserRouter>
);
